export const GOOGLE_OPTIMIZE_LOU_OSHIBA_TEST_ID = 'ecOL1bK6QPuPYRaZrQgYXw';
export const GOOGLE_OPTIMIZE_LOU_OSHIBA_PRO_PAGE_TEST_ID = 'YJqHr9QWTsGSzYfbyodNDg';
export const GOOGLE_OPTIMIZE_LOU_OSHIBA_VT_PAGE_TEST_ID = 'vKfZBhC6TTawYCvjZvA7Ww';
export const GOOGLE_OPTIMIZE_FILTER_AND_DISPLAY_THE_NUMBER_OF_PROFESSIONALS_WITHIN_A_REQUEST_FORM_TEST_ID =
  'Eb3PH3fFStOGgg5BRjGg_w';
export const GOOGLE_OPTIMIZE_SKIP_INTRO_TEST_ID = 'FXWluaEpQrK5xq9rKzLzpg';
export const GOOGLE_OPTIMIZE_NO_HEADER_TEST_ID = 'UerQDKkSQJ-rOzFrGVVVbA';
export const GOOGLE_OPTIMIZE_INTRO_STEP_DESC_TEST_ID = 'vFdzouQPQlC9Nnb5VLnfTA';
export const GOOGLE_OPTIMIZE_PROGRESS_BAR_PRO_SIGNUP_TEST_ID = 'la04TuXFSzC5FsWrjppx_w';
export const GOOGLE_OPTIMIZE_ONE_CLICK_PASS_TEST_ID = 'rNfGtbrFRamZFfkFaWwI5Q';
export const GOOGLE_OPTIMIZE_ICONIZATION_PHASE_FIVE_TEST_ID = 'Phf1LGRPTmm23Bi0NW5uTQ';
export const GOOGLE_OPTIMIZE_INCLUDE_SPONSOR_IMAGE_TEST_ID = '4wGTJ6vvTyKtQ2h1MHyeog';

export const GOOGLE_OPTIMIZE_CHAT_FLOW_TEST_ID = '-Dpk1E6uT5-rFzne2djPLg';

/**
 * If you are doing AB testing, put the ExperimentID in this array.
 */
export const OPTIMIZE_TEST_ID_LIST: Array<string> = [
  GOOGLE_OPTIMIZE_LOU_OSHIBA_TEST_ID,
  GOOGLE_OPTIMIZE_LOU_OSHIBA_PRO_PAGE_TEST_ID,
  GOOGLE_OPTIMIZE_FILTER_AND_DISPLAY_THE_NUMBER_OF_PROFESSIONALS_WITHIN_A_REQUEST_FORM_TEST_ID,
  GOOGLE_OPTIMIZE_SKIP_INTRO_TEST_ID,
  GOOGLE_OPTIMIZE_INTRO_STEP_DESC_TEST_ID,
  GOOGLE_OPTIMIZE_NO_HEADER_TEST_ID,
  GOOGLE_OPTIMIZE_PROGRESS_BAR_PRO_SIGNUP_TEST_ID,
  GOOGLE_OPTIMIZE_ONE_CLICK_PASS_TEST_ID,
  GOOGLE_OPTIMIZE_ICONIZATION_PHASE_FIVE_TEST_ID,
  GOOGLE_OPTIMIZE_INCLUDE_SPONSOR_IMAGE_TEST_ID,
  GOOGLE_OPTIMIZE_CHAT_FLOW_TEST_ID,
];
